module.exports = __webpack_public_path__ + "static/scale-model-of-statue-\"gandhi\"-in-long-beach-california-ac15069f3897c2aedf36c1738189fa7d.png";